
import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Insertnoticecase } from './insertnoticecase';
import { InsertChequeBouncingData } from './InsertChequeBouncingData';
import { delay, map, startWith } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { fillingOppositeParty } from '../create-noticecase/create-noticecase.component';
import { de } from 'date-fns/locale';

declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface FillingOppositeParty {
  ID: string;
  Name: string;
  Mobile: string;
  State: string;
  City: string;
  typ: string;
}
export class CaptionSetting {
  MainDescr: string;
  SubDescr: string;
  SelectedValue: string;
}
export interface INoticeProduct {
  ID: number;
  Remarks: string;
  ProductName: string;
  ProductCode: string;
  ProductID: string;
}
export interface Section {
  hdID: string;
  MainDescr: string;
}
export interface NoticeCaseStatus {
  NoticeStatus: string;
  ConvertinCase: string;
  refno: string;
}
@Injectable({ providedIn: 'root' })
@Component({
    selector: 'app-generate-notice',
    templateUrl: './generate-notice.component.html',
    styleUrls: ['./generate-notice.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class GenerateNoticeComponent implements OnInit {
  TypeHeader: string;
  Type: string;
  Sent: string;
  Received: string;
  id: any;
  Category: any;
  SubCategory: any;
  Company: any;
  chequeBounceCase: any;
  chequeBounceNotice: any;
  Department: any;
  Designation: any;
  Agency: any;
  AgencyCase: any;
  AgencyNotice: any;
  Manager: any;
  Leader: any;
  User: any;
  State: any;
  City: any;
  Jurisdiction: any;
  Stages: any;
  Seriousness: any;
  url: string;
  pageurl: string;
  RefNo: string;
  JudgeName: string;
  PoliceStation: string;
  PoliceStationCase: string;
  PoliceStationNotice: string;
  CourtNumberCase: string;
  CourtNumberNotice: string;
  InvestigatingOfficer: string;
  T_Department: string;
  FIRNo: string;
  FIRDate: string;
  FIRDateCase: string;
  FIRDateNotice: string;
  addFormNotice: FormGroup;
  ChequeBouncingForm: FormGroup;
  addFormFillingParty: FormGroup;
  addFormOppositeParty: FormGroup;
  addFormProduct: FormGroup;
  dynamicProductForm: FormGroup;
  addFormOrgContact: FormGroup;
  getdata: string;
  numb: any;
  DateofNotice: string;
  DueDate: string;
  LastDate: string;
  DateofReceiving: string;
  Currency: any;
  RoleID: any;
  CurrencyCase: any;
  CurrencyNotice: any;
  Lawyer: any;
  TargetDate: string;
  str: string;
  str1: string;
  fileurls = [];
  fileSize: string;
  fileName: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  NoticeCaseData: any;
  factsheetDetail: any;
  FetchContactRecord: any;
  modalURL: string;
  CallFunctionOnCloseModal: any;
  fetchfollowupData: any;
  fetchNoticeHistoryData: any;
  expenseDetail: any;
  DisplayExistNotice: string;
  selectedFillingParty = [];
  selectedOppositeParty = [];
  filteredFillingParty: fillingOppositeParty[] = [];
  filteredOppositeParty: fillingOppositeParty[] = [];
  FilingOppoParty: FillingOppositeParty[] = [];
  ContactList: FillingOppositeParty[] = [];
  SectionList: Section[] = [];
  ProductHelpList: Section[] = [];
  selectedSections = [];
  DisplaySaveNoticeButton: string;
  FetchExistingFillingParty: any;
  FetchExistingOppositeParty: any;
  HeaderButtonCaption: string;
  ModelFor: string;
  NoticeProductData: INoticeProduct[] = [];
  editable: boolean;
  clicked: boolean;
  DownloadURL: string;
  NoticeCaseStatus: string;
  ConvertinCaseNo: string;
  HideButtonSubmit: string;
  HideContent: string;
  RightsID: string;
  RouteGMSection: string;
  RouteGMAgency: string;
  RouteGMCategory: string;
  RouteGMSubCategory: string;
  RouteGMDepartment: string;
  RouteGMState: string;
  RouteGMNoticeStatus: string;
  RouteGMCaseStatus: string;
  RouteGMCity: string;
  RouteGMJurisdiction: string;
  RouteGMCurrency: string;
  RouteUserMaster: string;
  RouteCompany: string;
  RouteGMRegion: string;
  RouteGMBranch: string;
  LogData: any;
  AddFollowupLink: string;
  ManagerPreID: any;
  LeaderPreID: any;
  varInterval: any;
  PageStatus: string;
  CommunityRights: string;
  CommunityDisplayRegionBranch: string;
  Region: string;
  Branch: any;
  PreBenchNo: string;
  BenchCase: string;
  BenchNotice: string;
  PreJudgeName: string;
  DiaryValue: string;
  PreLawyerID: any;
  ExposureAmount: any;
  ExposureAmountCase: any;
  ExposureAmountNotice: any;
  NegotiateAmount: any;
  NegotiateAmountCase: any;
  NegotiateAmountNotice: any;
  RecoveryAmount: any;
  RecoveryAmountNotice: any;
  RecoveryAmountCase: any;
  InsuranceAmount: any;
  InsuranceAmountCase: any;
  InsuranceAmountNotice: any;
  BalanceAmount: any;
  BalanceAmountCase: any;
  BalanceAmountNotice: any;
  AmountDue: any;
  ReceivingAmount: any;
  againstchequebouncing: any;
  CaptionJurisdiction: any;
  CaptionShortName: any;
  CaptionExposurAmount: any;
  CaptionDateofReceiving: any;
  EcourtNo: string;
  EcourtTypeId: string;
  OriginalrefNo: string;
  EcourtType: Array<any> = [];

  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  ShowHideSharingOption: any;
  Court: any;
  CourtName: string;
  captionType: any;
  captionCaseCode: any;
  captionManager: any;
  captionCategory: any;
  captionSubCategory: any;
  captionProject: any;
  captionLeader: any;
  captionDateofFilingNotice: any;
  captionState: any;
  captionStatus: any;
  captionDateofReceivingNotice: any;
  captionCity: any;
  captionSeriousness: any;
  captionTargetDate: any;
  captionRegion: any;
  captionBranch: any;
  captionNextDateofHearing: any;
  captionDateofCase: any;
  captionDateofNotice: any;
  captionDateofFilingCase: any;
  captionDateofReceivingCase: any;
  captionSection: any;
  captionCompany: any;
  captionDepartment: any;
  captionBench: any;
  captionLawyer: any;
  captionCourtNumber: any;
  captionCurrency: any;
  captionRecoveryAmount: any;
  captionNegotiateAmount: any;
  captionBalanceAmount: any;
  captionFIRDate: any;
  captionAgency: any;
  captionFilingParty: any;
  captionOppositeParty: any;
  
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.CourtName = "e-Court Name";
    this.CommunityRights = localStorage.getItem('CommunityRights');
    if (this.CommunityRights.includes('202016000')) { this.CommunityDisplayRegionBranch = "1"; }
    //Cheque Bouncing Update Code Start

    this.http.get(this.url + 'Notice/ChequeBouncingStatus').subscribe((data) => {

      for (var val of JSON.parse(data.toString())) {
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Cheque Bounce Details') {
          this.chequeBounceNotice = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Cheque Bounce Details') {
          this.chequeBounceCase = val['SelectedValue'];
        }

        // Change for vatika (Remove Column Name)  <!-- Add for valika by Ankur-->
        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Agency') {
          this.AgencyCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Agency') {
          this.AgencyNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Bench No') {
          this.BenchCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Bench No') {
          this.BenchNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Currency') {
          this.CurrencyCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Currency') {
          this.CurrencyNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Recovery Amount') {
          this.RecoveryAmountCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Recovery Amount') {
          this.RecoveryAmountNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Negotiation Amount') {
          this.NegotiateAmountCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Negotiation Amount') {
          this.NegotiateAmountNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Balance Amount') {
          this.BalanceAmountCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Balance Amount') {
          this.BalanceAmountNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Exposure Amount') {
          this.ExposureAmountCase = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Exposure Amount') {
          this.ExposureAmountNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'FIR Date') {
          this.FIRDateCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'FIR Date') {
          this.FIRDateNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Insurance Amount') {
          this.InsuranceAmountCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Insurance Amount') {
          this.InsuranceAmountNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Police Station') {
          this.PoliceStationCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Police Station') {
          this.PoliceStationNotice = val['SelectedValue'];
        }

        if (val['MainDescr'] == 'Case' && val['SubDescr'] == 'Court No.') {
          this.CourtNumberCase = val['SelectedValue'];
        }
        if (val['MainDescr'] == 'Notice' && val['SubDescr'] == 'Court No.') {
          this.CourtNumberNotice = val['SelectedValue'];
        }

      }

    });

    //Cheque Bouncing  Update Code END
    this.FetchFillingOppositePartyList();
    this.FetchHelpContactList();
    this.ShowHideSharingOption = 0;
    this.modalURL = "/";
    this.ManagerPreID = 0;
    this.LeaderPreID = 0;
    this.pageurl = this.router.url;
    this.ExposureAmount = 1;
    this.NegotiateAmount = 0;
    this.RecoveryAmount = 0;
    this.BalanceAmount = 0;
    this.AmountDue = 0;
    this.ReceivingAmount = 0;
    this.againstchequebouncing = 0;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[3];
    this.CheckRights();
    this.getUserRoleID();
    //Caption Name Update Code Start
    this.http.get(this.url + 'Dashboard/CaptionData?id=')
      .subscribe((data:any) => {
        console.log(JSON.parse(data));
        for (var val of JSON.parse(data.toString())) {

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Jurisdiction/ Court Name') {
            this.CaptionJurisdiction = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Short Name') {
            this.CaptionShortName = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Exposure Amount') {
            this.CaptionExposurAmount = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Receiving') {
            this.CaptionDateofReceiving = val['SelectedValue'];
          }

          // Change for vatika (Renaming Column Name)  <!-- Add for valika by Ankur-->
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Ref No. *') {
            this.RefNo = val['SelectedValue'].replace("*", '');
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Ref No. *') {
            this.RefNo = val['SelectedValue']
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Judge Name') {
            this.JudgeName = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Police Station') {
            this.PoliceStation = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Investigating Officer Name') {
            this.InvestigatingOfficer = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Last Date to Respond') {
            this.LastDate = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Due Date') {
            this.DueDate = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'FIR No.') {
            this.FIRNo = val['SelectedValue'];
          }
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Company/Department') {
            this.str1 = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Add To Follow UP') {
            this.AddFollowupLink = val['SelectedValue'];
          }

          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Type') {
            this.captionType = val['SelectedValue'];
          }

          // Case Code
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Case Code') {
            this.captionCaseCode = val['SelectedValue'];
          }
          // Manager
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Manager') {
            this.captionManager = val['SelectedValue'];
          }
          // Category
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Category') {
            this.captionCategory = val['SelectedValue'];
          }
          // Sub Category
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Sub Category') {
            this.captionSubCategory = val['SelectedValue'];
          }
          // Project
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Project') {
            this.captionProject = val['SelectedValue'];
          }
          // Leader
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Leader') {
            this.captionLeader = val['SelectedValue'];
          }
          // Date of filing notice
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of filing notice') {
            this.captionDateofFilingNotice = val['SelectedValue'];
          }
          // Date of filing case
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of filing case') {
            this.captionDateofFilingCase = val['SelectedValue'];
          }
          // State
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'State') {
            this.captionState = val['SelectedValue'];
          }
          // Status
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Status') {
            this.captionStatus = val['SelectedValue'];
          }
          // Date of Receiving Notice
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Receiving Notice') {
            this.captionDateofReceivingNotice = val['SelectedValue'];
          }
          // Date of Receiving Case
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Receiving Case') {
            this.captionDateofReceivingCase = val['SelectedValue'];
          }
          // City
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'City') {
            this.captionCity = val['SelectedValue'];
          }
          // Seriousness
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Seriousness') {
            this.captionSeriousness = val['SelectedValue'];
          }
          // Target Date
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Target Date') {
            this.captionTargetDate = val['SelectedValue'];
          }
          // Region 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Region') {
            this.captionRegion = val['SelectedValue'];
          }
          // Branch
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Branch') {
            this.captionBranch = val['SelectedValue'];
          }
          // Next Date of Hearing
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Next Date of Hearing') {
            this.captionNextDateofHearing = val['SelectedValue'];
          }
          // Date of Case
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Case') {
            this.captionDateofCase = val['SelectedValue'];
          }
          // Date of Notice
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Date of Notice') {
            this.captionDateofNotice = val['SelectedValue'];
          }
          // Section 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Section') {
            this.captionSection = val['SelectedValue'];
          }
          // Company
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Company') {
            this.captionCompany = val['SelectedValue'];
          }
          // Department
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Department') {
            this.captionDepartment = val['SelectedValue'];
          }
          //Bench No
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Bench No') {
            this.captionBench = val['SelectedValue'];
          }
          // Lawyer Name
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Lawyer Name') {
            this.captionLawyer = val['SelectedValue'];
          }
          //  CourtNumber 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Court Number') {
            this.captionCourtNumber = val['SelectedValue'];
          }
          // Currency
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Currency') {
            this.captionCurrency = val['SelectedValue'];
          }
          //  Recovery Amount
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Recovery Amount') {
            this.captionRecoveryAmount = val['SelectedValue'];
          }
          //  Negotiate Amount 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Negotiate Amount') {
            this.captionNegotiateAmount = val['SelectedValue'];
          }
          // Balance Amount 
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Balance Amount') {
            this.captionBalanceAmount = val['SelectedValue'];
          }
          // FIR Date
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'FIR Date') {
            this.captionFIRDate = val['SelectedValue'];
          }
          //  Agency
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Agency') {
            this.captionAgency = val['SelectedValue'];
          }
          // Filing Party
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Filing Party') {
            this.captionFilingParty = val['SelectedValue'];
          }
          // Opposite Party
          if (val['MainDescr'].toUpperCase() == pagehead[2].toUpperCase() && val['SubDescr'] == 'Opposite Party') {
            this.captionOppositeParty = val['SelectedValue'];
          }

        }

        this.applyDynamicValidations();
      }
      );
    //Caption Name Update Code END
    if (pagehead[2] == "notice" || pagehead[2] == "Notice") {
      this.TypeHeader = 'Notice';
      this.Type = 'Notice';
      this.Sent = 'Sent';
      this.Received = 'Received';
      if (this.RightsID.includes('202030001') || this.RightsID.includes('202030021') || this.RightsID.includes('202030000')) {
      } else {
        window.location.href = "module/0";
      }
    } else if (pagehead[2] == 'case' || pagehead[2] == "Case") {
      this.TypeHeader = 'Case';
      this.Type = 'Case';
      this.Sent = 'Filled by Us';
      this.Received = 'Against Us';
      if (this.RightsID.includes('202032001') || this.RightsID.includes('202032021') || this.RightsID.includes('202032000')) {
      } else {
        window.location.href = "module/0";
      }
    }
    this.DisplayExistNotice = "!isHidden";
    this.HideButtonSubmit = "";
    this.HideContent = "";
    this.DisplaySaveNoticeButton = "submit";
    this.HeaderButtonCaption = "Create";
    this.dynamicProductForm = this.formBuilder.group({
      ExistingProductData: new FormArray([])
    });
    this.fetchRouteDataRights();
    //this.getLawyerName();
    this.getMasterData();
    if (this.id > 0) {
      this.HeaderButtonCaption = "Update";
      this.DisplayExistNotice = "";
      this.DisplaySaveNoticeButton = "submit";
      this.fetchNoticeCaseData();
      this.factSheetData();
      this.FetchContactDetail();
      this.FetchNoticeHistory();
      this.FetchExpenseDetail();

      this.FetchExistingFillingDetail();
      this.FetchExistingOppositeDetail();
      this.FetchNoticeProduct();
      this.FetchLogData();
    }
        this.createForm();
        this.applyDynamicValidations();
    // Set Validation of Add Notice /  Case Form on Header Part
    // this.addFormNotice = this.formBuilder.group({
    //   Notice: ['', Validators.required], Agency: [''], ShortName: [''], Manager: [null], Category: [0], SubCategory: [null], Company: [''], Currency: [''], Lawyer: [null],
    //   Department: [''], ExposureAmmount: [''], DateofNotice: ['', Validators.required], RefNo: ['', Validators.required],
    //   State: [null], Leader: [null], DateofReceiving: [''], TargetDate: [''], City: [null], Stages: [null], Jurisdiction: [''],
    //   Seriousness: [''], DueDate: [''], LastDate: [''], CourtName: [''], RecoveryAmount: [''], NegotiationAmount: [''],
    //   BalanceAmount: [{ value: '', disabled: true }], Section: [null], FIRDate: [''], FIRNo: [''], PoliceStation: [''], InvestigatingOfficer: [''], BenchNo: [''],
    //   JudgeName: [''], Region: [''], Branch: [''], LawyerName: [''], InsuranceAmount: [''], EcourtNo: [''], EcourtTypeId: [null], OriginalrefNo: [''],
    // });

    this.ChequeBouncingForm = this.formBuilder.group({
      AmountDue: [null, Validators.required], DateofReceivingAmount: [null, Validators.required], ReceivingAmount: [null,Validators.required], ModeOfPayment: [null, Validators.required], againstchequebouncing: [{ value: null, disabled: true }],
      TotalOSFromParty: [null, Validators.required], ChequeDate: [null, Validators.required], ChequeNo: [null, Validators.required], ChequeAmount: [null, Validators.required], DishonorDate: [null, Validators.required], DishonorReason: [null,Validators.required],
      DishonorBank: [null,Validators.required], DishonorBankBranch: [null, Validators.required]
    });
    // Set By Default Value on Header Part
    // this.addFormNotice.patchValue({
    //   Notice: '1', State: '0', Agency: '0', Manager: 0, Category: null, SubCategory: null, Company: '0', Department: '0',
    //   Leader: null, City: '0', Stages: '0', Jurisdiction: '0', Seriousness: '0', Currency: '0', Lawyer: null, Region: '0', Branch: '0',
    //   ExposureAmmount: '0', RecoveryAmount: '0', NegotiationAmount: '0', BalanceAmount: '0'
    // });

    // this.ChequeBouncingForm.patchValue({
    //   AmountDue: '0', ReceivingAmount: '0', againstchequebouncing: '0',
    //   TotalOSFromParty: '0', ChequeAmount: '0'
    // });
    this.addFormOppositeParty = this.formBuilder.group({
      oppositePartyName: [null]
    });
    this.addFormFillingParty = this.formBuilder.group({
      fillingPartyName: [null]
    });
    this.addFormOrgContact = this.formBuilder.group({
      OrgContactName: ['']
    });
    this.addFormProduct = this.formBuilder.group({
      HelpProduct: ['']
    });

    this.FetchSharing();
  }
  private createForm(): void {
    this.addFormNotice = this.formBuilder.group({
      Notice: [null],
      Section: [null],
      FIRNo: [''],
      EcourtTypeId: [null],
      EcourtNo: [''],
      OriginalrefNo: [''],
      RefNo: [''],
      ShortName: [''],
      Manager: [null],
      Category: [null],
      SubCategory: [null],

      Company: [null],
      Department: [null],

      Leader: [null],
      DateofNotice: [null],
      State: [null],
      Stages: [null],
      DateofReceiving: [null],
      City: [null],
      Seriousness: [null],
      TargetDate: [null],
      Jurisdiction: [null],
      ExposureAmmount: [null],

      BenchNo: [''],
      JudgeName: [''],
      Lawyer: [null],
      InvestigatingOfficer: [''],

      DueDate: [null],
      LastDate: [null],
      CourtNumber: [''],
      Currency: [null],
      RecoveryAmount: [''],
      NegotiationAmount: [''],
      BalanceAmount: [''],
      FIRDate: [null],
      Agency: [null],
      PoliceStation: [null],
      InsuranceAmount: [''],

      Region: [null],
      Branch: [null],
    });
  }
  private applyDynamicValidations(): void {
  this.setRequired([
    'Notice',
    'Section',
    'RefNo',
    'ShortName',
    'Manager',
    'Category',
    'SubCategory',
    'Leader',
    'DateofNotice',
    'State',
    'Stages',
    'DateofReceiving',
    'City',
    'TargetDate',
    'ExposureAmmount',
    'DueDate',
    'LastDate',
  ]);

  this.applyProjectVsCompanyLogic();
  this.applyCaseVsNoticeLogic();
  this.applyFeatureFlagLogic();
}
private applyProjectVsCompanyLogic(): void {
  console.log(this.str1);
  if (this.str1 === 'Project') {
    this.setRequired(['Department']);
    this.clearRequired(['Company']);
  } else {
    this.setRequired(['Company', 'Department']);
  }
}
private applyCaseVsNoticeLogic(): void {
  if (this.TypeHeader === 'Case') {
    this.setRequired(['JudgeName', 'Lawyer']);

    if (this.str1 !== 'Project') {
      this.setRequired(['InvestigatingOfficer']);
    }
  }
}
private applyFeatureFlagLogic(): void {

  // Bench No
  if (
    (this.Type === 'Case' && this.BenchCase === '1') ||
    (this.Type === 'Notice' && this.BenchNotice === '1')
  ) {
    this.setRequired(['BenchNo']);
  }

  // Court Number
  if (
    (this.Type === 'Case' && this.CourtNumberCase === '1') ||
    (this.Type === 'Notice' && this.CourtNumberNotice === '1')
  ) {
    this.setRequired(['CourtNumber']);
  }

  // Currency
  if (
    (this.Type === 'Case' && this.CurrencyCase === '1') ||
    (this.Type === 'Notice' && this.CurrencyCase === '1')
  ) {
    this.setRequired(['Currency']);
  }

  // Recovery / Negotiation / Balance
  if (
    (this.Type === 'Case' && this.RecoveryAmountCase === '1') ||
    (this.Type === 'Notice' && this.RecoveryAmountNotice === '1')
  ) {
    this.setRequired(['RecoveryAmount']);
  }

  if (
    (this.Type === 'Case' && this.NegotiateAmountCase === '1') ||
    (this.Type === 'Notice' && this.NegotiateAmountNotice === '1')
  ) {
    this.setRequired(['NegotiationAmount']);
  }

  if (
    (this.Type === 'Case' && this.BalanceAmountCase === '1') ||
    (this.Type === 'Notice' && this.BalanceAmountNotice === '1')
  ) {
    this.setRequired(['BalanceAmount']);
  }

  // FIR Date
  if (
    (this.Type === 'Case' && this.FIRDateCase === '1') ||
    (this.Type === 'Notice' && this.FIRDateNotice === '1')
  ) {
    this.setRequired(['FIRDate']);
  }

  // Agency / Police
  if (
    (this.Type === 'Case' && this.AgencyCase === '1') ||
    (this.Type === 'Notice' && this.AgencyNotice === '1')
  ) {
    this.setRequired(['Agency']);
  }

  if (
    (this.Type === 'Case' && this.PoliceStationCase === '1') ||
    (this.Type === 'Notice' && this.PoliceStationNotice === '1')
  ) {
    this.setRequired(['PoliceStation']);
  }

  // Insurance
  if (
    (this.Type === 'Case' && this.InsuranceAmountCase === '1') ||
    (this.Type === 'Notice' && this.InsuranceAmountNotice === '1')
  ) {
    this.setRequired(['InsuranceAmount']);
  }

  // Region / Branch
  if (this.CommunityDisplayRegionBranch === '1') {
    this.setRequired(['Region', 'Branch']);
  }
}
private setRequired(fields: string[]): void {
  fields.forEach(field => {
    const control = this.addFormNotice.get(field);
    if (control) {
      control.setValidators([Validators.required]);
      control.updateValueAndValidity();
    }
  });
}

private clearRequired(fields: string[]): void {
  fields.forEach(field => {
    const control = this.addFormNotice.get(field);
    if (control) {
      control.clearValidators();
      control.updateValueAndValidity();
    }
  });
}

  fetchRouteDataRights() {
    // tslint:disable-next-line: max-line-length
    this.RouteCompany = this.RightsID.includes('202044000') || this.RightsID.includes('202044001') || this.RightsID.includes('202044021') ? '/navcompany/company/0' : '/module/0';
    // tslint:disable-next-line: max-line-length
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? '/user-master' : '/module/0';
    if (this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021')) {
      this.RouteGMSection = "/general-master/070";
      this.RouteGMAgency = "/general-master/040";
      this.RouteGMCategory = "/general-master/045";
      this.RouteGMSubCategory = "/general-master/050";
      this.RouteGMDepartment = "/general-master/030";
      this.RouteGMState = "/general-master/010";
      this.RouteGMNoticeStatus = "/general-master/105";
      this.RouteGMCaseStatus = "/general-master/110";
      this.RouteGMCity = "/general-master/015";
      this.RouteGMJurisdiction = "/general-master/020";
      this.RouteGMCurrency = "/general-master/115";
      this.RouteGMRegion = "/general-master/085";
      this.RouteGMBranch = "/general-master/090";
    } else {
      this.RouteGMRegion = "/module/0";
      this.RouteGMBranch = "/module/0";
      this.RouteGMSection = "/module/0";
      this.RouteGMAgency = "/module/0";
      this.RouteGMCategory = "/module/0";
      this.RouteGMSubCategory = "/module/0";
      this.RouteGMDepartment = "/module/0";
      this.RouteGMState = "/module/0";
      this.RouteGMNoticeStatus = "/module/0";
      this.RouteGMCaseStatus = "/module/0";
      this.RouteGMCity = "/module/0";
      this.RouteGMJurisdiction = "/module/0";
      this.RouteGMCurrency = "/module/0";
    }
  }
  // function f() for display validation on header part
  get f() { return this.addFormNotice.controls; }
  get c() { return this.ChequeBouncingForm.controls; }
  get t() { return this.dynamicProductForm.controls.ExistingProductData as FormArray; }
  CheckRights() {

    this.http.get(this.url + 'Notice/Fetch_Notice_Case_Status?id=' + this.id)
      .subscribe((data) => {
        if (data == null) {
        } else {
          const noticeCaseStatus: NoticeCaseStatus = JSON.parse(data.toString())[0];
          this.NoticeCaseStatus = noticeCaseStatus.NoticeStatus;
          this.ConvertinCaseNo = noticeCaseStatus.ConvertinCase;
          if (this.NoticeCaseStatus == "1") {
            this.HeaderButtonCaption = "Re-Work";
            this.HideContent = "!isHidden";
          }
          if (this.ConvertinCaseNo != null) {
            this.PageStatus = "Note: This Notice Converted in Case Ref No (" + noticeCaseStatus.refno + " )";
            this.HideButtonSubmit = "!isHidden";
            this.HideContent = "!isHidden";
          } else { this.PageStatus = ""; }
        }
      }
      );
  }
  onRegionSelect(GenID) {
    this.getMaster('090', GenID.hdID).subscribe((data: any) => { this.Branch = data; });
  }
  onStateSelect(value) {
    if (this.addFormNotice.get('EcourtTypeId').value != null && this.addFormNotice.get('EcourtTypeId').value != '') {
      const EcourtTypeID = this.addFormNotice.get('EcourtTypeId').value.hdID;
      this.GetMasterecourtwise('015', value.hdID, EcourtTypeID).subscribe((data: any) => {
        this.City = data;
        let data1: any;
        this.Jurisdiction = data1;
        this.addFormNotice.patchValue({ City: null, Jurisdiction: null });
      });
    }else{
      this.getMaster('015', value.hdID).subscribe((data: any) => {
        this.City = data;
        let data1: any;
        this.Jurisdiction = data1;
        this.addFormNotice.patchValue({ City: null, Jurisdiction: null });
      });
    }
  }
  onCitySelect(GenID) {
    this.getMaster('020', GenID.hdID).subscribe((data: any) => {
      this.Jurisdiction = data;
      this.addFormNotice.patchValue({ Jurisdiction: null });
    });
  }
  onCategorySelect(GenID) {
    this.getMaster('050', GenID.hdID).subscribe((data: any) => {
      this.SubCategory = data;
      this.addFormNotice.patchValue({ SubCategory: null });
    });
  }

  getUserRoleID() {

    this.http.get(this.url + 'Notice/GetRoleID').subscribe((data) => {
      if (data == null) {
        this.RoleID = null;
      }
      else {

        for (var val of JSON.parse(data.toString())) {
          this.RoleID = val['ROLEID'];
        }


      }
    }
    );

  }
  getMasterData() {
    this.getMaster('085', '').subscribe((data: any) => { this.Region = data; });
    // Section= 070
    this.getMaster('070', '').subscribe((data: any) => {
      this.SectionList = data;
    });
    this.getMaster('115', '').subscribe((data: any) => {
      this.Currency = data;
    });
    // Product= 075
    this.getMaster('075', '').subscribe((data: any) => {
      this.ProductHelpList = [{ hdID: '', MainDescr: 'Select Product' }, ...data];
    });
    // 40 = Agency Record
    this.getMaster('040', '').subscribe((data: any) => {
      this.Agency = data;
    });
    // 10 = State Record
    this.getMaster('010', '').subscribe((data: any) => {
      this.State = data;
    });
    // 45= Category Record
    this.getMaster('045', '').subscribe((data: any) => {
      this.Category = data;
    });
    // 30= Department
    this.getMaster('030', '').subscribe((data: any) => {
      this.Department = data;
    });
    // 35= Designation

    this.getMaster('135', '').subscribe((data: any) => {
      this.EcourtTypeId = data;
    });



    /************For Get Stages*************  */
    if (this.TypeHeader == 'Notice') {
      this.getMaster('105', '').subscribe((data: any) => {
        this.Stages = data;
      });
    } else {
      this.getMaster('110', '').subscribe((data: any) => {
        this.Stages = data;
      });
    }

    /********** For Get Compant Master Name List ****** */
    this.http.get(this.url + 'Notice/GetCompanyMasterList').subscribe((data) => {
      this.Company = JSON.parse(data.toString());
    });
    /********** For Get Contact Manager Name ****** */
    this.http.get(this.url + 'GM/GetEmployee').subscribe((data) => {
      this.Manager = JSON.parse(data.toString());
    });
    /************For Get Seriousness************* */
    this.getSysData('010').subscribe((data: any) => {
      this.Seriousness = data;
    });
    /************For Get LawyerName************* */
    this.http.get(this.url + 'Help/FetchHelpLawyerName').subscribe((data) => {
      this.Lawyer = JSON.parse(data.toString());
    });
  }
  getSysData(GID: string) {
    return this.http.get(this.url + 'SysData/GetSysData?GenID=' + GID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  // For Bind Field on Page Load Like Company, Department, State, Agency, City
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }

  GetMasterecourtwise(GID: string, MID: string, TYPEID: string) {

    return this.http.get(this.url + 'GM/GetMasterecourtwise?GenID=' + GID + '&MainID=' + MID + '&TypeId=' + TYPEID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  OpenModal(url, cID, urld, modelName) {

    // tslint:disable-next-line: max-line-length
    if ((modelName == "Add Notice Diary" && this.TypeHeader == 'Case') || (modelName == "Update Notice Diary" && this.TypeHeader == 'Case')) {
      this.modalURL =  url + "/" + this.id + "/" + cID + "/" + "2";
    } else if (modelName == 'Evaluation Form') {
      this.modalURL =  url + "/" + this.id + "/" + cID;
    }
    // sharing option
    else if (modelName == 'Sharing Option') {
      this.modalURL =  url + "/" + this.id + "/" + cID;
    }
    // sharing option
    else {
      this.modalURL =  url + "/" + this.id + "/" + cID + "/" + "0";
    }
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
  }
  fetchNoticeCaseData() {

    this.http.get(this.url + 'Notice/FetchExistingNotice?ID=' + this.id)
      .subscribe((data) => {

        if (data == null) {
          this.NoticeCaseData = null;
        } else {
          const fetchHeaderdata: Insertnoticecase = JSON.parse(data.toString())[0];
          if (fetchHeaderdata.StateID != null) {
            this.getMaster('015', fetchHeaderdata.StateID.toString()).subscribe((data: any) => {
              this.City = data; let data1: any; this.Jurisdiction = data1;
            });
          }
          if (fetchHeaderdata.NoticeRegion != null) {
            this.getMaster('090', fetchHeaderdata.NoticeRegion).subscribe((data: any) => { this.Branch = data; });
          }
          if (fetchHeaderdata.CityID != null) {
            this.getMaster('020', fetchHeaderdata.CityID.toString()).subscribe((data: any) => { this.Jurisdiction = data; });
          }
          if (fetchHeaderdata.CategoryID != null) {
            this.getMaster('050', fetchHeaderdata.CategoryID.toString()).subscribe((data: any) => { this.SubCategory = data; });
          }

          this.getMaster('070', '').subscribe((data: any) => {
            this.SectionList = data;
            if (fetchHeaderdata.Section != null) {
              this.selectedSections = fetchHeaderdata.Section.toString().split('~').map(Number);
            }
          });

          if (this.AddFollowupLink == "" || this.AddFollowupLink == undefined) {
            this.AddFollowupLink = "Add To Follow Up";
          }

          if (localStorage.getItem('LoginUserID').toString() == fetchHeaderdata.ManagerID.toString()) {
            localStorage.setItem('Feedback', "");
            this.AddFollowupLink = this.AddFollowupLink;
          } else if (localStorage.getItem('LoginUserID').toString() == fetchHeaderdata.LeaderID.toString()) {
            this.AddFollowupLink = "Add To Feedback";
            localStorage.setItem('Feedback', "Feedback");
          } else {
            localStorage.setItem('Feedback', "");
            this.AddFollowupLink = this.AddFollowupLink;
          }

          this.PreBenchNo = fetchHeaderdata.BenchNo;
          this.PreJudgeName = fetchHeaderdata.JudgeName;
          this.PreLawyerID = fetchHeaderdata.LawyerID == null ? 0 : fetchHeaderdata.LawyerID;
          this.ManagerPreID = fetchHeaderdata.ManagerID == null ? 0 : fetchHeaderdata.ManagerID;
          this.LeaderPreID = fetchHeaderdata.LeaderID == null ? 0 : fetchHeaderdata.LeaderID;
          this.ExposureAmount = fetchHeaderdata.ExposureAmt == null ? 0 : fetchHeaderdata.ExposureAmt;
          this.NegotiateAmount = fetchHeaderdata.NegotiationAmt == null ? 0 : fetchHeaderdata.NegotiationAmt;
          this.RecoveryAmount = fetchHeaderdata.ReceivedAmt == null ? 0 : fetchHeaderdata.ReceivedAmt;
          this.BalanceAmount = fetchHeaderdata.BalanceAmt == null ? 0 : fetchHeaderdata.BalanceAmt;
          this.addFormNotice.patchValue({
            Region: fetchHeaderdata.NoticeRegion,
            Branch:  fetchHeaderdata.NoticeBranch,
            Agency:  fetchHeaderdata.AgencyID, ShortName: fetchHeaderdata.ShortName,
            Manager:  fetchHeaderdata.ManagerID,
            Currency:  fetchHeaderdata.CurrencyID,
            Lawyer:  fetchHeaderdata.LawyerID,
            DateofReceiving: fetchHeaderdata.ReceiptDt == null ? "" : fetchHeaderdata.ReceiptDt,
            Category:  fetchHeaderdata.CategoryID, DateofNotice: fetchHeaderdata.NoticeDt,
            SubCategory:  fetchHeaderdata.SubCategoryID,
            InsuranceAmount:  fetchHeaderdata.InsuranceAmount,
            ExposureAmmount:  fetchHeaderdata.ExposureAmt,
            Notice: fetchHeaderdata.IsSent == false ? "0" : "1",
            Company:  fetchHeaderdata.CompanyID,
            Department:  fetchHeaderdata.DeptID, RefNo: fetchHeaderdata.refno,
            State:  fetchHeaderdata.StateID,
            BalanceAmount:  fetchHeaderdata.BalanceAmt,
            TargetDate: fetchHeaderdata.TargetDt == null ? "" : fetchHeaderdata.TargetDt,
            Leader:  fetchHeaderdata.LeaderID,
            DueDate: fetchHeaderdata.DueDt == null ? "" : fetchHeaderdata.DueDt,
            NegotiationAmount:  fetchHeaderdata.NegotiationAmt,
            City:  fetchHeaderdata.CityID,
            LastDate: fetchHeaderdata.LastDateToRespond == null ? "" : fetchHeaderdata.LastDateToRespond,
            Stages:  fetchHeaderdata.Stages, CourtName: fetchHeaderdata.CourtNo,
            Jurisdiction:  fetchHeaderdata.CourtID,
            RecoveryAmount:  fetchHeaderdata.ReceivedAmt,
            Seriousness:  fetchHeaderdata.Seriousness == "" ? null : fetchHeaderdata.Seriousness,
            FIRNo: fetchHeaderdata.FIRNo, FIRDate: fetchHeaderdata.FIRDate == null ? "" : fetchHeaderdata.FIRDate,
            PoliceStation: fetchHeaderdata.PoliceStation, InvestigatingOfficer: fetchHeaderdata.InvestigatingOfficer,
            BenchNo: fetchHeaderdata.BenchNo, JudgeName: fetchHeaderdata.JudgeName, LawyerName: fetchHeaderdata.LawyerName,
            Section:Number(fetchHeaderdata.Section),
            EcourtTypeId: fetchHeaderdata.EcourtTypeId,
            EcourtNo: fetchHeaderdata.EcourtNo,
            OriginalrefNo: fetchHeaderdata.OriginalrefNo
          });
          const fetchChequeBouncingdata: InsertChequeBouncingData = JSON.parse(data.toString())[0];
          this.AmountDue =  fetchChequeBouncingdata.AmtDue;
          this.ReceivingAmount =  fetchChequeBouncingdata.ReceivingAmt;
          this.againstchequebouncing =  fetchChequeBouncingdata.againstchequebouncing;
          this.ChequeBouncingForm.patchValue({
            AmountDue:  fetchChequeBouncingdata.AmtDue,
            ReceivingAmount:  fetchChequeBouncingdata.ReceivingAmt,
            againstchequebouncing:  fetchChequeBouncingdata.againstchequebouncing,
            TotalOSFromParty:  fetchChequeBouncingdata.TotalOSFromParty,
            ChequeAmount:  fetchChequeBouncingdata.ChequeAmt,
            DateofReceivingAmount: fetchChequeBouncingdata.ReceivingAmtDt == null ? "" : fetchChequeBouncingdata.ReceivingAmtDt,
            ModeOfPayment: fetchChequeBouncingdata.ModePayment == null ? "" : fetchChequeBouncingdata.ModePayment,
            ChequeDate: fetchChequeBouncingdata.ChequeDt == null ? "" : fetchChequeBouncingdata.ChequeDt,
            ChequeNo: fetchChequeBouncingdata.ChequeNo == null ? "" : fetchChequeBouncingdata.ChequeNo,
            DishonorDate: fetchChequeBouncingdata.DishonorDt == null ? "" : fetchChequeBouncingdata.DishonorDt,
            DishonorBank: fetchChequeBouncingdata.DishonorBank == null ? "" : fetchChequeBouncingdata.DishonorBank,
            DishonorBankBranch: fetchChequeBouncingdata.DishonorBankBranch == null ? "" : fetchChequeBouncingdata.DishonorBankBranch,
            DishonorReason: fetchChequeBouncingdata.DishonorReason == null ? "" : fetchChequeBouncingdata.DishonorReason
          });
        }
      }
      );
  }
  factSheetData() {
    this.http.get(this.url + 'Notice/FetchFactSheet?NoticeID=' + this.id + '&Type=0')
      .subscribe((data) => {
        if (data == null) {
          this.factsheetDetail = null;
        } else {
          this.factsheetDetail = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }
      );
  }
  FetchLogData() {
    this.http.get(this.url + 'Notice/FetchLogData?ID=' + this.id)
      .subscribe((data) => {
        if (data == null) {
          this.LogData = null;
        } else {
          this.LogData = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }
      );
  }
  FetchFollowup() {
    let followupid = "";
    this.http.get(this.url + 'Notice/FetchFollowUP?NoticeID=' + this.id + '&FollowupID=' + followupid)
      .subscribe((data) => {
        if (data == null) {
          this.fetchfollowupData = null;
        } else {
          this.fetchfollowupData = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }
      );
  }
  FetchNoticeHistory() {
    this.http.get(this.url + 'Notice/FetchNoticeHistory?NoticeID=' + this.id + '&Type=0')
      .subscribe((data) => {
        if (data == null) {
          this.fetchNoticeHistoryData = null;
        } else {
          this.fetchNoticeHistoryData = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }
      );
  }
  FetchExpenseDetail() {
    this.http.get(this.url + 'Notice/FetchExpense?NoticeID=' + this.id + '&ExpenseID=' + '')
      .subscribe((data) => {
        if (data == null) { this.expenseDetail = null; } else {
          this.expenseDetail = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }
      );
  }

  // sharing option
  FetchSharing() {

    this.http.get(this.url + 'Notice/GetSharingUser?NoticeID=' + this.id + '')
      .subscribe((data) => {
        this.ShowHideSharingOption = 0;
        if (data == null) {

          this.ShowHideSharingOption = 0;

        }
        else {

          this.ShowHideSharingOption = 1;
        }
      }
      );
  }
  // sharing option

  // e-Court Select
  onCourtSelect(value) {
    this.http.get(this.url + 'Notice/GetEcourtTypeIntergrationName?GenId=135&TYPE=' + value.hdID)    // Update CNR by Direct
      .subscribe((data) => {

        if (JSON.parse(data.toString())[0].Description == "null" || JSON.parse(data.toString())[0].Description == "") {
          this.CourtName = "e-Court Name";
        }
        else {
          this.CourtName = JSON.parse(data.toString())[0].Description;
          this.EcourtType.push(value.hdID);
        }
      });
  }
  // e-Court Select

  DeleteAttachment(deleteID) {
    if (this.HideContent == "!isHidden") {
      this.alertService.showError(" You can not delete it");
      return;
    }
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if (result) {
        this.http.get(this.url + 'Notice/DeleteAttachment?ID=' + deleteID)
          .subscribe((data) => {
            if (data == null) {
              this.factsheetDetail = null; this.factSheetData(); this.FetchFollowup(); this.FetchNoticeHistory();
            } else {
              this.alertService.showSuccess(" Successfully Removed");
              this.factSheetData(); this.FetchFollowup(); this.FetchNoticeHistory();
            }
          }
          );
      }
    })
  }

  DeleteExpense(ExpenseID) {
    if (this.HideContent == "!isHidden") {
      this.alertService.showError(" You can not delete it");
      return;
    }
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if (result) {
        this.http.get(this.url + 'Notice/DeleteExpense?ExpenseID=' + ExpenseID)
          .subscribe((data) => {
            if (data == null) {
              this.expenseDetail = null;
            } else {
              this.alertService.showSuccess(" Successfully Deleted"); this.FetchExpenseDetail();
            }
          }
          );
      }
    })
  }
  deleteFActSheet(DelContextID) {
    if (this.HideContent == "!isHidden") {
      this.alertService.showError(" You can not delete it");
      return;
    }
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if (result) {
        this.http.get(this.url + 'Notice/DeleteFactSheet?ContextID=' + DelContextID)
          .subscribe((data) => {
            if (data == null) {
              this.factsheetDetail = null; this.factSheetData();
            } else {
              this.alertService.showSuccess(" Successfully Deleted");
              this.factSheetData();
            }
          }
          );
      }
    });
  }
  onChangeNegotiateAmount(NegotiateAmount) {
    this.NegotiateAmount = NegotiateAmount == '' ? 0 : NegotiateAmount;
    this.BalanceAmount = this.ExposureAmount - this.NegotiateAmount - this.RecoveryAmount;
    this.addFormNotice.patchValue({
      ExposureAmmount: this.ExposureAmount, RecoveryAmount: this.RecoveryAmount,
      NegotiationAmount: this.NegotiateAmount, BalanceAmount: this.BalanceAmount
    });
  }
  onChangeRecoveryAmount(RecoverAmount) {
    this.RecoveryAmount = RecoverAmount == '' ? 0 : RecoverAmount;
    this.BalanceAmount = this.ExposureAmount - this.NegotiateAmount - this.RecoveryAmount;
    this.addFormNotice.patchValue({
      ExposureAmmount: this.ExposureAmount, RecoveryAmount: this.RecoveryAmount,
      NegotiationAmount: this.NegotiateAmount, BalanceAmount: this.BalanceAmount
    });
  }
  onChangeExposureAmount(ExposeAmount) {
    this.ExposureAmount = ExposeAmount == '' ? 0 : ExposeAmount;
    this.BalanceAmount = this.ExposureAmount - this.NegotiateAmount - this.RecoveryAmount;
    this.addFormNotice.patchValue({
      ExposureAmmount: this.ExposureAmount, RecoveryAmount: this.RecoveryAmount,
      NegotiationAmount: this.NegotiateAmount, BalanceAmount: this.BalanceAmount
    });
  }
  onChangeAmountDue(AmountDue) {
    this.AmountDue = AmountDue == '' ? 0 : AmountDue;
    this.againstchequebouncing = this.AmountDue - this.ReceivingAmount;
    this.ChequeBouncingForm.patchValue({ AmountDue: this.AmountDue, ReceivingAmount: this.ReceivingAmount, againstchequebouncing: this.againstchequebouncing });
  }
  onChangeReceivingAmount(ReceivingAmount) {
    this.ReceivingAmount = ReceivingAmount == '' ? 0 : ReceivingAmount;
    this.againstchequebouncing = this.AmountDue - this.ReceivingAmount;
    this.ChequeBouncingForm.patchValue({ AmountDue: this.AmountDue, ReceivingAmount: this.ReceivingAmount, againstchequebouncing: this.againstchequebouncing });
  }
  // For Get Fact Sheet Files in Base64 format
  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    this.fileSize = '';
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName += event.target.files[i].name + ',';
        this.fileSize += event.target.files[i].size + ',';
        let reader = new FileReader();
        reader.onload = (event: any) => { this.fileurls.push(event.target.result); };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }
  FetchExistingFillingDetail() {
    this.http.get(this.url + 'Notice/FetchFillingPartyDetail?NoticeID=' + this.id)
      .subscribe((data) => {
        if (data == null) {
          this.FetchExistingFillingParty = null;
        } else {
          this.FetchExistingFillingParty = JSON.parse(data.toString());
          this.filteredOppositeParty = this.FilingOppoParty.filter(option => !this.FetchExistingFillingParty.some(fp => fp.ContactID == option.ID));
          this.modalURL = '/';
        }
      }
      );
  }

  onProductADD(ProductData) {
    if (ProductData.HelpProduct == "" || ProductData.HelpProduct == null) {
      this.alertService.showWarning("Please Select Product First");
      return;
    }
    if (this.NoticeProductData != null) {
      for (let i = 0; i < this.NoticeProductData.length; i++) {
        if (this.NoticeProductData[i].ProductID.toString() == ProductData.HelpProduct.toString()) {
          this.alertService.showWarning("Already Exist");
          return;
        }
      }
    }
    // tslint:disable-next-line: max-line-length
    this.http.get(this.url + 'Notice/InsertProduct?NoticeID=' + this.id + '&ProductID=' + ProductData.HelpProduct + '&recuser=' + localStorage.getItem('LoginUserID'))
      .subscribe((data) => {
        if (data == null) {
          this.alertService.showError("Check Your InterNet Connection, Try Again Later",);
        } else {
          this.alertService.showSuccess("Successfully Add Product");
          this.FetchNoticeProduct();
          this.addFormProduct = this.formBuilder.group({ HelpProduct: [''] });
        }
      }
      );
  }
  DeleteNoticeProduct(ProductID) {
    if (this.HideContent == "!isHidden") {
      this.alertService.showError(" You can not delete it");
      return;
    }
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if (result) {
        this.http.get(this.url + 'Notice/DeleteNoticeProduct?ID=' + this.NoticeProductData[ProductID].ID)
          .subscribe((data) => {
            if (data == null) {
              this.alertService.showError(" You can not delete it");
            } else {

              this.alertService.showSuccess("Successfully Deleted");
              this.FetchNoticeProduct();
            }
          })
      }
    });
  }
  FetchNoticeProduct() {
    if (this.NoticeProductData != null) {
      for (let i = this.NoticeProductData.length; i >= 0; i--) {
        this.t.removeAt(i);
      }
    }
    this.http.get(this.url + 'Notice/FtechNoticeProduct?NoticeID=' + this.id)
      .subscribe((data) => {
        if (data == null) { this.NoticeProductData = null; } else {
          this.NoticeProductData = JSON.parse(data.toString());
          for (let i = this.t.length; i < this.NoticeProductData.length; i++) {
            this.t.push(this.formBuilder.group({
              ID: this.NoticeProductData[i].ID,
              Remarks: this.NoticeProductData[i].Remarks,
              ProductName: this.NoticeProductData[i].ProductName,
              ProductCode: this.NoticeProductData[i].ProductCode,
              recUser: localStorage.getItem('LoginUserID')
            }));
          }
        }
      }
      );
  }
  onProductUpdate() {
    this.http.post(this.url + 'Notice/UpdateNoticeProduct', this.t.value).subscribe((data) => {
      if (data == null) {
        this.alertService.showError(" Updation Failed ");
      } else {
        this.alertService.showSuccess("Successfully Updated");
      }
    }
    );
  }
  onOrgContactSubmit(OrgContactData) {
    if (OrgContactData.OrgContactName == "" || OrgContactData.OrgContactName == null) {
      this.alertService.showWarning("Please Select Contact or Organization");
      return;
    }
    if (this.FetchContactRecord != null) {
      for (let i = 0; i < this.FetchContactRecord.length; i++) {
        if (this.FetchContactRecord[i].ContactID.toString() == OrgContactData.OrgContactName.toString()) {
          this.alertService.showWarning("Already Exist");
          return;
        }
      }
    }
    // tslint:disable-next-line: max-line-length
    this.http.get(this.url + 'Notice/InsertExistingContactInNotice?NoticeID=' + this.id + '&ContactID=' + OrgContactData.OrgContactName + '&recuser=' + localStorage.getItem('LoginUserID'))
      .subscribe((data) => {
        if (data == null) {
          this.alertService.showWarning("Please Check your Internet Connection");
        } else {
          this.FetchContactDetail();
          this.alertService.showSuccess("Successfully Add Contact");
          this.addFormOrgContact = this.formBuilder.group({
            OrgContactName: ['']
          });
        }
      }
      );
  }
  FetchHelpContactList() {
    this.http.get(this.url + 'Help/FetchHelpContactOrg?Type=0')
      .subscribe((data) => {
        if (data == null) {
          this.ContactList = null; this.modalURL = '/';
        } else {
          this.ContactList = JSON.parse(data.toString()); this.modalURL = '/';
          this.ContactList = [{ ID: '', Name: 'Select Name', Mobile: '', State: '', City: '', typ: '' }].concat(this.ContactList);
        }
      }
      );
  }
  FetchContactDetail() {
    this.http.get(this.url + 'Notice/FetchContactDetail?NoticeID=' + this.id)
      .subscribe((data) => {
        if (data == null) {
          this.FetchContactRecord = null; this.modalURL = '/';
        } else {
          this.FetchContactRecord = JSON.parse(data.toString()); this.modalURL = '/';
        }
      }
      );
  }
  deleteNoticeContact(DelNoticeContactID: string) {
    if (this.HideContent == "!isHidden") {
      this.alertService.showError(" You can not delete it");
      return;
    }
    this.alertService.showConfirm('Are you sure to delete it?').then((result) => {
      if (result) {
        this.http.get(this.url + 'Notice/DeleteNoticeContact?ID=' + DelNoticeContactID)
          .subscribe((data) => {
            if (data == null) {
              this.FetchContactRecord = null;
              this.FetchContactDetail();
              this.FetchExistingOppositeDetail();
              this.FetchExistingFillingDetail(); this.modalURL = '/';
            } else {
              this.alertService.showSuccess("Successfully Deleted");
              this.FetchContactDetail();
              this.FetchExistingOppositeDetail();
              this.FetchExistingFillingDetail(); this.modalURL = '/';
            }
          });
      }
    })
  }
  FetchExistingOppositeDetail() {
    this.http.get(this.url + 'Notice/FetchOppositePartyDetail?NoticeID=' + this.id)
      .subscribe((data) => {
        if (data == null) {
          this.FetchExistingOppositeParty = null;
        } else {
          this.FetchExistingOppositeParty = JSON.parse(data.toString());
          this.filteredFillingParty = this.FilingOppoParty.filter(option => !this.FetchExistingOppositeParty.some(fp => fp.ContactID == option.ID));
        }
      }
      );
  }

  FetchFillingOppositePartyList() {
    this.http.get(this.url + 'Help/FetchHelpFillingOpposite')
      .subscribe((data) => {
        if (data == null) {
          this.FilingOppoParty = null;
        } else {
          this.FilingOppoParty = JSON.parse(data.toString());
        }
      }
      );
  }
  onFillingPartySubmit(fillingPartyData) {
    if (fillingPartyData.fillingPartyName == "" || fillingPartyData.fillingPartyName == null) {
      this.alertService.showWarning("Please Select Filling Party First");
      return;
    }
    if (this.FetchExistingFillingParty != null) {
      for (let i = 0; i < this.FetchExistingFillingParty.length; i++) {
        if (this.FetchExistingFillingParty[i].ContactID.toString() == fillingPartyData.fillingPartyName.toString()) {
          this.alertService.showWarning("Already Exist");
          return;
        }
      }
    }
    // tslint:disable-next-line: max-line-length
    this.http.get(this.url + 'Notice/InsertFillingParty?NoticeID=' + this.id + '&ContactID=' + fillingPartyData.fillingPartyName + '&recuser=' + localStorage.getItem('LoginUserID'))
      .subscribe((data) => {
        if (data == null) {
          this.fetchfollowupData = null;
        } else {
          this.FetchExistingFillingDetail();
          this.addFormFillingParty = this.formBuilder.group({
            fillingPartyName: [null]
          });
        }
      }
      );
  }
  onOppositePartySubmit(OppositePartyData) {
    if (OppositePartyData.oppositePartyName == "" || OppositePartyData.oppositePartyName == null) {
      this.alertService.showWarning("Please Select Opposite Party First");
      return;
    }
    if (this.FetchExistingOppositeParty != null) {
      for (let i = 0; i < this.FetchExistingOppositeParty.length; i++) {
        if (this.FetchExistingOppositeParty[i].ContactID.toString() == OppositePartyData.oppositePartyName.toString()) {
          this.alertService.showWarning("Already Exist");
          return;
        }
      }
    }
    // tslint:disable-next-line: max-line-length
    this.http.get(this.url + 'Notice/InsertOppositeParty?NoticeID=' + this.id + '&ContactID=' + OppositePartyData.oppositePartyName + '&recuser=' + localStorage.getItem('LoginUserID'))
      .subscribe((data) => {
        if (data == null) {
          this.fetchfollowupData = null;
        } else {
          this.FetchExistingOppositeDetail();
          this.addFormOppositeParty = this.formBuilder.group({
            oppositePartyName: [null]
          });
        }
      }
      );
  }
  CloseRecord() {

    let Closepagehead = this.pageurl.split('/');
    this.DiaryValue = "1";
    if (Closepagehead[2].toString().toUpperCase() == "NOTICE") {
      this.DiaryValue = "0";
    }
    if (Closepagehead[2].toString().toUpperCase() == "CASE") {
      this.DiaryValue = "2";
    }
    if (this.DiaryValue == "0") {
      window.location.href = "udc/" + this.id + "/CloseDiaryNotice/" + this.DiaryValue + "";
    }
    else if (this.DiaryValue == "2") {
      window.location.href = "udc/" + this.id + "/CloseDiaryCase/" + this.DiaryValue + "";
    }
    else {
      window.location.href = "udc/" + this.id + "/CloseDiary/" + this.DiaryValue + "";
    }

  }

  FinalVerdict() {
    let Closepagehead = this.pageurl.split('/');
    this.DiaryValue = "1";
    window.location.href = "FinalVerdict/" + this.id + "/1";

  }

  // Save Notice or Case
  ConvertNoticeinCase() {
    this.alertService.showConfirm('Are you sure to Convert in Case?').then((result) => {
      if (result) {
        this.http.get(this.url + 'Notice/ConvertNoticeToCase?id=' + this.id + '&status=1')
          .subscribe((data) => {
            if (data == null) {
            } else {
              this.alertService.showSuccess("Successfully Converted");
              this.ngOnInit();
            }
          });
      }
    })
  }
  getInvalidControls(form: FormGroup) {
  const invalidControls: { [key: string]: any } = {};

  Object.keys(form.controls).forEach(controlName => {
    const control = form.get(controlName);
    if (control?.invalid) {
      invalidControls[controlName] = control;
    }
  });

  return invalidControls;
}

  onHeaderSubmit(HearderFormData) {
      this.addFormNotice.markAllAsTouched();
      if (this.addFormNotice.invalid) {
        return;
      }
    if (this.HeaderButtonCaption == "Re-Work") {
      this.http.get(this.url + 'Notice/CloseReworkNoticeCase?id=' + this.id + '&status=0')
        .subscribe((data) => {
          this.ngOnInit();
          if (data == null) {
          } else {
            return;
          }
        }
        );
    } else {

      if (HearderFormData.RefNo == "") { this.clicked = false; this.alertService.showWarning("Please Enter Refno"); this.clicked = false; return; }

      if (this.addFormNotice.invalid) { this.clicked = false; this.alertService.showWarning("Please Enter All Mandatory Fields"); return; }

      if (HearderFormData.Notice == "") {


        this.clicked = false;
        if (this.Type == "Notice") {
          this.alertService.showWarning("Please Select Notice Type Received or Sent");
        } else { this.alertService.showWarning("Please Select Case Type Filled By Us or Against Us"); } return;
      } else {
        this.numb = 1;
        let noticeobj: Insertnoticecase = {
          id: this.id,
          refno: HearderFormData.RefNo,
          ShortName: HearderFormData.ShortName,
          Type: this.Type,
          IsSent: HearderFormData.Notice,
          CurrencyID: HearderFormData.Currency,
          LawyerID: HearderFormData.Lawyer,
          NoticeDt: HearderFormData.DateofNotice,
          ReceiptDt: HearderFormData.DateofReceiving,
          TargetDt: HearderFormData.TargetDate,
          DueDt: HearderFormData.DueDate,
          CategoryID: HearderFormData.Category,
          SubCategoryID: HearderFormData.SubCategory,
          ExposureAmt: HearderFormData.ExposureAmmount,
          NegotiationAmt: HearderFormData.NegotiationAmount,
          InsuranceAmount: HearderFormData.InsuranceAmount,
          ReceivedAmt: HearderFormData.RecoveryAmount,
          BalanceAmt: HearderFormData.BalanceAmount,
          CompanyID: HearderFormData.Company,
          DeptID: HearderFormData.Department,
          StateID: HearderFormData.State,
          CityID: HearderFormData.City,
          CourtID: HearderFormData.Jurisdiction,
          CourtNo: HearderFormData.CourtName,
          LastDateToRespond: HearderFormData.LastDate,
          AgencyID: HearderFormData.Agency,
          ManagerID: HearderFormData.Manager,
          LeaderID: HearderFormData.Leader,
          Stages: HearderFormData.Stages,
          Seriousness: HearderFormData.Seriousness,
          recEnable: this.numb,
          recUser: this.numb,
          recAddUser: this.numb,
          Section: HearderFormData.Section.toString(),
          FIRDate: HearderFormData.FIRDate,
          FIRNo: HearderFormData.FIRNo,
          PoliceStation: HearderFormData.PoliceStation,
          InvestigatingOfficer: HearderFormData.InvestigatingOfficer,
          ManagerPreID: this.ManagerPreID,
          LeaderPreID: this.LeaderPreID,
          BenchNo: HearderFormData.BenchNo,
          JudgeName: HearderFormData.JudgeName,
          LawyerName: HearderFormData.LawyerName,
          NoticeRegion: HearderFormData.Region,
          NoticeBranch: HearderFormData.Branch,
          PreBenchNo: this.PreBenchNo,
          PreJudgeName: this.PreJudgeName,
          PreLawyerID: this.PreLawyerID,

          EcourtTypeId: HearderFormData.EcourtTypeId,
          EcourtNo: HearderFormData.EcourtNo,
          OriginalrefNo: HearderFormData.OriginalrefNo


        };
        this.http.post(this.url + 'Notice/insertNoticeCase', noticeobj).subscribe((data) => {

          this.clicked = false;
          if (data == null) {
            this.alertService.showError("Some Error In Entered Record");
          } else {
            if (this.id == 0) {
              this.alertService.showSuccess(this.TypeHeader + " Add Successfully");
            } else {
              this.alertService.clear();
              this.alertService.showSuccess(this.TypeHeader + " Updated Successfully");
            }
            data = data.toString().split(':');
            this.getdata = data[1].toString().split('}');
            this.id = this.getdata[0].toString();
            this.HeaderButtonCaption = "Update";
            this.DisplayExistNotice = "";
            this.DisplaySaveNoticeButton = "submit";
          }
        }
        );
      }
    }
  }
  onChequeBouncingUpdate(ChequeBouncingData) {
    if (this.ChequeBouncingForm.invalid) {
      this.ChequeBouncingForm.markAllAsTouched();
      return;
    }
    let ChequeBouncingobj: InsertChequeBouncingData = {
      id: this.id,
      AmtDue: ChequeBouncingData.AmountDue,
      ReceivingAmtDt: ChequeBouncingData.DateofReceivingAmount,
      Type: this.Type,
      ModePayment: ChequeBouncingData.ModeOfPayment,
      ChequeDt: ChequeBouncingData.ChequeDate,
      ChequeNo: ChequeBouncingData.ChequeNo,
      againstchequebouncing: ChequeBouncingData.againstchequebouncing,
      ReceivingAmt: ChequeBouncingData.ReceivingAmount,
      TotalOSFromParty: ChequeBouncingData.TotalOSFromParty,
      ChequeAmt: ChequeBouncingData.ChequeAmount,
      DishonorDt: ChequeBouncingData.DishonorDate,
      DishonorReason: ChequeBouncingData.DishonorReason,
      recEnable: this.numb,
      recUser: this.numb,
      recAddUser: this.numb,
      DishonorBank: ChequeBouncingData.DishonorBank,
      DishonorBankBranch: ChequeBouncingData.DishonorBankBranch
    };
    this.http.post(this.url + 'Notice/insertChequeBouncingData', ChequeBouncingobj).subscribe((data) => {
      this.clicked = false;
      if (data == null) {
        this.alertService.showError("Some Error In Entered Record");
      } else {
        if (this.id == 0) {
          this.alertService.showSuccess('Cheque Bouncing Data Added Successfully');
        } else {
          this.alertService.clear();
          this.alertService.showSuccess('Cheque Bouncing Data Updated Successfully');
        }
        data = data.toString().split(':');
        this.getdata = data[1].toString().split('}');
        this.id = this.getdata[0].toString();
      }
    }
    );
  }
  /* for Print in PDF*/
  getPDF() {
    var newWindow = window.open();
    newWindow.document.write('Downloading ...');
    this.http.get(this.url + 'ReportConfig/GetCasePDF?CaseID=' + this.id)
      .subscribe((data) => {
        //newWindow.location.href = this.DownloadURL + data;
        window.open(this.DownloadURL + data, '_blank', 'width-800,height-800,left-200,top-200');
        newWindow.close();
        // this.varInterval = setInterval(() => {
        //   if (newWindow.document.readyState == 'complete') {

        //     clearInterval(this.varInterval);
        //   }
        // }, 200);
      }
      );
  }

  CallPython(event: any) {
    ;
    event.target.disabled = true;
    //this.http.get(this.url + 'Notice/cnrMiddleWare?cnrid=' + this.addFormNotice.controls.RefNo.value+"~"+this.pageurl.split('/')[3]) // Update CNR by Middleware
    this.http.get(this.url + 'Notice/cnrDirect?cnrid=' + this.addFormNotice.controls.RefNo.value + "~" + this.pageurl.split('/')[3])    // Update CNR by Direct
      .subscribe((data) => {
        if (data == null) {
          event.target.disabled = false;
          this.alertService.showError(" Updation Failed ");
          location.reload();
        }
        else if (data == 'Data Already Updated') {
          event.target.disabled = false;
          this.alertService.showSuccess("Data Already Updated");
          location.reload();
        }
        else if (data == 'Data Not Available on Website.') {
          event.target.disabled = false;
          this.alertService.showError("Data Not Available on Website.");
          location.reload();
        }
        else if ((data.toString()).includes('One or more errors occurred.') || (data.toString()).includes('Try Again')) {
          event.target.disabled = false;
          this.alertService.showError("Data Not Found or Server Error");
          location.reload();
        }
        else {
          event.target.disabled = false;
          this.alertService.showSuccess("Successfully Updated");
          location.reload();
        }
      }
      );
  }

  goBack() {
    if (this.pageurl.split('/')[2] == "Notice") {
      this.router.navigate(['nav/notice/0/update']);  
    }else{
      this.router.navigate(['nav/case/0/update']);
    }
  }

}




